//@ts-nocheck
import { roundCurrency } from './currencyHelper';

const toNumber = (value) => {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : 0;
};

const isRemovedDiscount = (discount = {}) =>
  discount.isdeleted === true || discount.isDeleted === true;

export const getActiveBookingDiscountTotal = (bookingDiscounts = []) => {
  if (!Array.isArray(bookingDiscounts)) return 0;

  return roundCurrency(
    bookingDiscounts
      .filter((discount) => !isRemovedDiscount(discount))
      .reduce((total, discount) => {
        const discountAmount = toNumber(
          discount.discountAmount ?? discount.discountamount
        );

        return total + Math.abs(discountAmount);
      }, 0)
  );
};

export const getDiscountAdjustedPriceAdjustment = (
  priceAdjustment = 0,
  bookingDiscounts = []
) =>
  roundCurrency(
    toNumber(priceAdjustment) - getActiveBookingDiscountTotal(bookingDiscounts)
  );
